import { Component, h, Element, Listen } from "@stencil/core";

@Component({
    tag: 'snt-wysiwyg',
    styleUrl: 'wysiwyg-component.scss',
    shadow: false
})


export class WYSIWYGComponent {

    @Element() el: HTMLElement;

    @Listen('click', { target: 'document' })
    handleClick(ev) {
      let targetElement = ev.target;
      

      while (targetElement != null) {
        if (targetElement.classList.contains('play-button')) {
          var iframe = document.createElement('iframe');
          let videoContainer = targetElement.parentElement.parentElement;
          if (videoContainer.classList.contains("youtube")) {
            var id = videoContainer.dataset.id;
            iframe.setAttribute('src', `https://www.youtube.com/embed/${id}?autoplay=1`);
          } else if (videoContainer.classList.contains("vidyard")) {
            var id = videoContainer.dataset.id;
            iframe.setAttribute('src', `https://play.vidyard.com/${id}.html?autoplay=1`);
          }
          iframe.setAttribute('frameborder', '0');
          iframe.setAttribute('allowfullscreen', '1');
          iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
          iframe.style.width = '100%';
          iframe.style.height = '100%';
          videoContainer.innerHTML = '';
          videoContainer.appendChild(iframe);
        }
        targetElement = targetElement.parentElement;
      }
      
    }
  
    componentWillLoad() {
        // SCMS-1522: remove blog article schema
        this.el.querySelectorAll('.blog-post-body div[itemtype]').forEach(d => {
            d.removeAttribute('itemtype');
            d.removeAttribute('itemscope');
        })
    }

    render() {
        return (
            <div>
                <slot></slot>
            </div>
        );
    }
}